import React from "react";
import { motion } from "framer-motion";
import { exportData } from "../Data";
import mapImg1 from '../Images/map-1.png'
import mapImg2 from '../Images/map-2.png'

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" }
  }
};

const container = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
      delayChildren: 0.2
    }
  }
};

const Export = () => {
  return (
    <section className="export-section">

      {/* BACKGROUND MAPS (NO ANIMATION) */}
      <img src={mapImg1} alt="Map Vector 1 | VigoFlex" className="map-bg map-bg-left" />
      <img src={mapImg2} alt="Map Vector 2 | VigoFlex" className="map-bg map-bg-right" />

      <div className="container">

        {/* TOP */}
        <motion.div
          className="export-top text-center"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.h3 className="section-subheading" variants={fadeUp}>
            Global Reach. Flexible Solutions.
          </motion.h3>

          <motion.h2 className="section-heading" variants={fadeUp}>
            Serving Global Markets with Flexible Packaging Solutions
          </motion.h2>

          <motion.p className="section-text" variants={fadeUp}>
            Delivering across borders with efficiency and reliability, VigoFlex supports global markets with export-ready capabilities and flexible, customized packaging solutions tailored to diverse project and regional requirements.
          </motion.p>
        </motion.div>

        {/* CARDS */}
        <motion.div
          className="export-grid"
          variants={container}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          {exportData.map((item, i) => (
            <motion.div
              className="export-card"
              key={i}
              variants={fadeUp}
              whileHover={{ y: -6 }}
              transition={{ duration: 0.2 }}
            >

              {/* HEADER */}
              <div className="export-card-header">
                <div className="export-icon">
                  <img src={item.icon} alt={`${item.heading} Icon | VigoFlex`} />
                </div>

                <div>
                  <h4 className="card-heading">{item.heading}</h4>
                  <p className="section-text">{item.subheading}</p>
                </div>
              </div>

              {/* IMAGE (NO SCALE — SAFE) */}
              <div className="export-image">
                <img src={item.img} alt={`${item.heading} | VigoFlex`} />
              </div>

              {/* POINTS */}
              <div className="export-points">
                {item.points.map((p, idx) => (
                  <motion.div
                    className="export-point"
                    key={idx}
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.4, delay: idx * 0.08 }}
                    viewport={{ once: true }}
                  >
                    <img src={p.icon} alt={`${p.title} | VigoFlex`} />
                    <h5>{p.title}</h5>
                    <p className="section-text">{p.desc}</p>
                  </motion.div>
                ))}
              </div>

            </motion.div>
          ))}
        </motion.div>

      </div>
    </section>
  );
};

export default Export;